<template>
  <div>
    <div class="onchainatm-style" v-if="isMobile">
      <toppage></toppage>
      <div class="onchainatm-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>链上AML服务</h1>

            <div class="header-info">
              <span>海量数据模型</span>
              <span>完备标签体系</span>
            </div>
            <div class="header-info">
              <span>链上态势感知</span>
              <span>数据指标分析</span>
            </div>
          </div>
        </div>
        <div class="main-background">
          <div class="main-content">
            <h1>服务行业&机构</h1>
            <div class="curreny-content">
              <span class="content-info">
                <img
                  src="@/assets/image/mobile/onchainatm/jianguan.png"
                  alt=""
                />
                <span>监管机构</span>
              </span>
              <span class="content-info">
                <img src="@/assets/image/mobile/onchainatm/zhifa.png" alt="" />
                <span>执法机构 </span>
              </span>
              <span class="content-info">
                <img
                  src="@/assets/image/mobile/onchainatm/jinrong.png"
                  alt=""
                />
                <span>金融机构 </span>
              </span>
            </div>
            <div class="curreny-content">
              <span class="content-info">
                <img src="@/assets/image/mobile/onchainatm/meiti.png" alt="" />
                <span>媒体机构</span>
              </span>
              <span class="content-info">
                <img src="@/assets/image/mobile/onchainatm/kaifa.png" alt="" />
                <span>开发者</span>
              </span>
              <span class="content-info">
                <img src="@/assets/image/mobile/onchainatm/jichu.png" alt="" />
                <span>基础设施服务商</span>
              </span>
            </div>
            <div class="curreny-content">
              <span class="content-info">
                <img src="@/assets/image/mobile/onchainatm/xueshu.png" alt="" />
                <span>学术研究</span>
              </span>
              <span class="content-info">
                <img src="@/assets/image/mobile/onchainatm/geren.png" alt="" />
                <span>个人研究者</span>
              </span>
              <span class="content-info"> &nbsp; </span>
            </div>
          </div>
        </div>
        <footerpage></footerpage>
      </div>
      <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="../../assets/image/newhome/huidaodingbu.png" alt="">

    </div>
    <div class="onchainatm-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section onchainatm-top">
          <div>
            <div class="onchainatm-nav">
              <navbar
                classname="businessintroduce"
                childclassname="onchainatm"
              ></navbar>
            </div>
            <div class="section-content">
              <div class="top-title">
                <div class="title-info">
                  <div class="info-content">
                    <h1>链上AML服务</h1>
                  </div>
                </div>
                <!-- <div class="title-content">
             <img src="@/assets/image/newhome/businessintroduce/bannerbeijing.gif" alt="">
            </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="section onchainatm-profession">
          <div
            class="profession-content animated-element1"
            v-show="isprofession"
          >
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info">
                  <h1>服务行业&机构</h1>
                  <div class="onchainatm-currency">
                    <div class="content-main">
                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets//image/newhome/onchainatm/jianguan.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>监管机构</span>
                        </div>
                      </div>
                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets/image/newhome/onchainatm/zhifa.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>执法机构</span>
                        </div>
                      </div>
                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets//image/newhome/onchainatm/jinrong.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>金融机构</span>
                        </div>
                      </div>
                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets//image/newhome/onchainatm/meiti.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>媒体机构</span>
                        </div>
                      </div>
                    </div>

                    <div class="content-main">
                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets//image/newhome/onchainatm/kaifa.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>开发者</span>
                        </div>
                      </div>
                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets//image/newhome/onchainatm/jichu.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>基础设施服务商</span>
                        </div>
                      </div>
                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets//image/newhome/onchainatm/xueshu.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>学术研究</span>
                        </div>
                      </div>

                      <div class="main-info">
                        <div>
                          <img
                            src="../../assets//image/newhome/onchainatm/geren.png"
                            alt=""
                          />
                        </div>
                        <div class="main-right">
                          <span>个人研究者</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="liucheng-button">
              <span>联系我们</span>
            </div> -->
              </div>
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </div>
</template>
<script>
import navbar from "@/components/navbar.vue";
import newfooter from "@/components/newfooter.vue";
// import countTo  from 'vue-count-to';
// import CountUp from "countup"
import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";
export default {
  components: {
    navbar,
    newfooter,
    // countTo
    toppage,
    footerpage,
  },
  data() {
    return {
      deviceType: this.getDeviceType(),
      showButton: false,
      scrollThreshold: 400,
      isMobile: false,
      // isshebi:false,
      // iscorebusiness1:false,
      // iscorebusiness2:false,
      isprofession: false,
      screenWidth: 0,
      bannerHeight: 0,
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true,
        afterLoad: this.afterLoad,
        onLeave: this.onLeave,

        //为每个section设置背景色
        // sectionsColor: [
        //     "#41b883",
        //     "#ff5f45",
        //     "#0798ec",
        //     "#fec401",
        //     "#1bcee6",
        //     "#ee1a59",
        //     "#2c3e4f",
        //     "#ba5be9",
        //     "#b4b8ab"
        // ],
      },
    };
  },
  methods: {
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
    getDeviceType() {
      return window.innerWidth < 768 ? "手机" : "电脑";
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
    afterLoad(anchorLink, index) {
      console.log(anchorLink, index);
      console.log("Emitted 'after load' event.");
      //获取body的classname，跟随section滑动刷新
      let a = document.body.className;
      console.log(a);
      //在第几页控制相关逻辑
      //   if(a !== 'fp-scroll-mac fp-viewing-0' || a !== 'fp-viewing-0'){
      //     this.isshebi=false
      //   }

      if (a !== "fp-scroll-mac fp-viewing-1" || a !== "fp-viewing-1") {
        this.isprofession = false;
      }
      if (a === "fp-scroll-mac fp-viewing-1" || a === "fp-viewing-1") {
        // console.log(eee);
        this.isprofession = true;
      }
      // else if(a === 'fp-scroll-mac fp-viewing-0' || a === 'fp-viewing-0'){
      //   this.isshebi=true
      // }
    },

    next() {
      // 向下滚动一页
      this.$refs.fullpage.api.moveSectionUp();
      // this.$refs.fullpage.goTo(0);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
  },
  // created(){     location.reload()},
  mounted() {
    if (this.deviceType != "手机" && !this.isMobile) {
      this.next();
    }
    if(this.isMobile){

window.addEventListener('scroll', () => {
  this.showButton = window.scrollY > this.scrollThreshold;
});
}
    // 首次加载时,初始化高度
    this.screenWidth = window.innerWidth;
    this.bannerHeight = (450 / 1450) * this.screenWidth;
    // 窗口大小发生改变
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (450 / 1450) * this.screenWidth;
    };
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', () => {});

  },
};
</script>
<style>
.fp-warning,
.fp-watermark {
  display: none !important;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/onchainatm.scss";
</style>
